const Footer = () => {
    return (
        <div>
            <footer className="footer mt-auto py-3 bg-dark">
                <div className="container">
                    <p className="text-light">App desenvolvido por <a href="https://github.com/RafaelSouzaJava" target="_blank" rel="noreferrer">Rafael de Souza Alves</a></p>
                    <p className="text-light">Linkedin: <a href="https://www.linkedin.com/in/rafael-souza-alves-86b3071b2/" target="_blank" rel="noreferrer">Rafael de Souza Alves</a></p>
                    <p className="text-light"><small><strong>Semana Spring React</strong><br />
                        Evento promovido pela escola DevSuperior: <a href="https://instagram.com/devsuperior.ig" target="_blank" rel="noreferrer">@devsuperior.ig</a></small></p>
                </div>
            </footer>
        </div>
    );
}

export default Footer;